import { base64toBlob, showPdf } from '@/services/blobutility'
import Button from '@/components/buttons/Button'
import Download from '../component/Download'
import _get from 'lodash/get'
import { boardDocumentStore } from '@/services/BoardDocument/store'
import { parseDate } from '@/utilities/Date/parse'
import { notifyMessage, notifyProblem, notifyWarning } from '@/services/notify'

export const methods = {
  determineRows: async function(list) {
    if (!Array.isArray(list)) {
      return
    }

    var rows = list.map(entry => {
      const category = _get(entry, 'boardDocumentCategoryDto.name', '')
      const description = _get(entry, 'description', '')
      //const documentName = _get(entry, 'description', '')
      const createdDate = parseDate(_get(entry, ['createdDate'], ''), 'LL')
      const boardDocumentID = _get(entry, ['boardDocumentID'], 0)

      return {
        category: category,
        description: description,
        uploaded: createdDate,
        edit: {
          component: Button,
          props: {
            onClick: () => {
              this.redirectToEdit(entry)
            },
            text: 'Edit'
          }
        },
        delete: {
          component: Button,
          props: {
            onClick: async () => {
              await this.confirmDeleteDocument(boardDocumentID, description)
            },
            text: 'Delete'
          }
        },
        document: {
          component: Download,
          props: {
            boardDocumentID: _get(entry, ['boardDocumentID'], 0),
            downloadPdf: boardDocumentID => {
              this.downloadPdf(boardDocumentID)
            }
          }
        }
      }
    })

    this.rows = rows
  },

  createBoardDocumentModal() {
    this.toggle = true
    this.selectedBoardDocument = null
  },

  redirectToEdit(boardDocumentID) {
    this.toggle = true
    this.selectedBoardDocument = boardDocumentID
  },

  async confirmDeleteDocument(boardDocumentID, documentName) {
    this.$buefy.dialog.confirm({
      title: 'Deleting Board Document',
      message: `Are you sure you want to <b>delete</b> this board document, "${documentName}"?`,
      confirmText: 'Delete Document',
      type: 'is-danger',
      hasIcon: true,
      onConfirm: () => this.deleteBoardDocument(boardDocumentID)
    })
  },

  async deleteBoardDocument(boardDocumentID) {
    if (boardDocumentID) {
      await boardDocumentStore.dispatch('deleteBoardDocument', {
        boardDocumentID: boardDocumentID,
        done: () => {
          this.loading = false
          this.reload()
        }
      })
    }
  },

  async downloadPdf(boardDocumentID) {
    if (this.isDebug == true) console.debug('downloadPdf...')

    if (!boardDocumentID || boardDocumentID == undefined) {
      notifyProblem('There is a problem downloading this document.')
    }

    try {
      const params = {
        boardDocumentID,
        asBase64: true,
        asRawBase64: true
      }

      await boardDocumentStore.dispatch('getDocumentFile', {
        params,
        done: ({ details }) => {
          if (details) {
            if (this.isDebug == true) console.debug('base64pdf........................' + details)

            const contentType = 'application/pdf'
            const blob = base64toBlob(details, contentType)
            showPdf(blob)
            notifyMessage(`Successfully downloaded the board document.`)
            return
          }
        }
      })
    } catch (e) {
      if (this.isDebug == true) console.debug(e)
      notifyWarning('There was a problem downloading the board document.')
    }
  },

  async loadBoardDocuments() {
    if (this.isDebug == true) console.debug('in loadBoardDocuments()...')

    await boardDocumentStore
      .dispatch('getBoardDocumentList', {
        hoaID: this.hoaId
      })
      .then(async ({ list }) => {
        await this.determineRows(list)
      })
  },

  async reload() {
    this.loading = true

    this.rows = []
    await this.loadBoardDocuments()

    this.loading = false
  }
}
